import { i18nFormat } from '@unionfab/ufc-shop-commons';
import { message } from 'antd';
import cn from 'classnames';

import CustomerIcon from '@/assets/images/new-shop-quote/customer.svg';
import LinkIcon from '@/assets/images/new-shop-quote/link.svg';
import styles from './NewShopQuoteMobile.module.less';

interface NewShopQuoteMobileProps {
  className?: string;
  style?: Record<string, string | number>;
}

export const NewShopQuoteMobile = ({
  className,
  style,
}: NewShopQuoteMobileProps) => {
  const handleCopyLink = async () => {
    const href = window.location.href;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(href);
      } else {
        const input = document.createElement('textarea');
        input.value = href;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }

      message.success(i18nFormat('Link copied successfully'));
    } catch (error) {
      console.error('>>>NewShopQuoteMobile>>>copyLink', error);
      message.error(i18nFormat('Copy failed. Please try again.'));
    }
  };

  return (
    <div style={style} id="NewShopQuote" className={cn(className, styles.page)}>
      <div className={styles.hero}>
        <img
          className={styles.heroImage}
          src="https://0.assets.sunionfab.com/ufc-oversea/uoms/images/phone/top-img.png?x-oss-process=image/format,webp/quality,Q_85"
          alt="Desktop quote"
        />
      </div>

      <h1 className={styles.title}>
        {i18nFormat('Continue Your Quote on Desktop')}
      </h1>
      <p className={styles.description}>
        {i18nFormat(
          'CAD upload and instant pricing are currently optimized for desktop browsers. Send or copy this secure quote link, then open it on your computer to continue.',
        )}
      </p>

      <button
        className={styles.copyButton}
        type="button"
        onClick={handleCopyLink}
      >
        <LinkIcon className={styles.copyButtonIcon} />
        <span>{i18nFormat('Copy Link to Open on Desktop')}</span>
      </button>

      <p className={styles.copyHint}>
        {i18nFormat(
          '*No desktop nearby? Save the copied link and reopen it later on your computer.',
        )}
      </p>

      <div className={styles.helpLink}>
        <CustomerIcon className={styles.helpIcon} />
        <span>
          {i18nFormat('Need help?')}{' '}
          <a className={styles.helpEmail} href="mailto:hello@unionfab.com">
            hello@unionfab.com
          </a>
        </span>
      </div>

      <div className={styles.steps}>
        <div className={styles.stepsTrack}>
          <div className={styles.stepsLine} />
          <div className={styles.step}>
            <span className={styles.stepDot}>1</span>
            <span className={styles.stepLabel}>
              {i18nFormat('Upload CAD Files')}
            </span>
          </div>
          <div className={styles.step}>
            <span className={styles.stepDot}>2</span>
            <span className={styles.stepLabel}>
              {i18nFormat('Automatic File Analysis')}
            </span>
          </div>
          <div className={styles.step}>
            <span className={styles.stepDot}>3</span>
            <span className={styles.stepLabel}>
              {i18nFormat('Accurate Instant Quote')}
            </span>
          </div>
        </div>
        <div className={cn(styles.step, styles.stepDone, styles.stepLast)}>
          <span className={styles.stepCheck}>
            <svg
              className={styles.stepCheckIcon}
              viewBox="0 0 12 12"
              aria-hidden="true"
            >
              <path d="M2 6.2L4.6 8.8L10 3.4" />
            </svg>
          </span>
        </div>
      </div>

      <a
        className={styles.contactLink}
        href="https://www.unionfab.com/contact-us"
      >
        {i18nFormat('Contact Us')}
      </a>
    </div>
  );
};

NewShopQuoteMobile.displayName = 'NewShopQuoteMobile';
